<template>
  <Head :title="config.title.charAt(0).toUpperCase() + config.title.slice(1)" />
  <div class="w-full flex justify-between">
    <h1 class="mb-8 text-3xl font-bold" style="text-transform: capitalize">
      {{ config.title }}
    </h1>
    <Link
      v-if="config.print"
      :href="config.print"
      class="rounded-sm flex items-center ml-auto px-5 py-0 text-indigo-600 border border-indigo-600 h-10 capitalize hover:bg-indigo-600 hover:text-white font-bold"
    >
      print
    </Link>
  </div>
  <div class="flex items-center justify-between mb-6">
    <slot name="filter" />
    <Link
      v-if="showButtonCreate"
      class="flex items-center btn-indigo ml-auto"
      :href="'/' + config.title + '/create'"
    >
      <span>Create</span>
      <span class="hidden md:inline">&nbsp;{{ config.title }}</span>
    </Link>
  </div>
  <div class="rounded-md bg-white shadow overflow-x-auto">
    <table class="border-collapse table-auto w-full">
      <tr class="text-left font-bold">
        <th class="pb-4 pt-6 px-6">No.</th>
        <th v-for="(table, idx) in config.table" :key="idx" class="pb-4 pt-6 px-6">
          {{ table.title }}
        </th>
      </tr>
      <tr
        v-for="(row, idx) in data.data"
        :key="row.id"
        class="hover:bg-gray-100 focus-within:bg-gray-100"
      >
        <td class="w-px border-t">
          <Link
            class="flex items-center px-4"
            :href="`/${config.title}/${row.id}/edit`"
            tabindex="-1"
          >
            {{ idx + 1 }}
          </Link>
        </td>
        <td v-for="(table, idx) in config.table" :key="idx" class="border-t">
          <Link
            v-if="table.field === 'status_name'"
            :href="`/${config.title}/${row.id}/edit`"
            class="flex items-center px-6 py-2 focus:text-indigo-500"
            v-html="row[table.field]"
          />
          <Link
            v-else
            class="flex items-center px-6 py-2 focus:text-indigo-500"
            :href="`/${config.title}/${row.id}/edit`"
          >
            {{ row[table.field] }}
          </Link>
        </td>

        <td class="w-px border-t">
          <Link
            class="flex items-center px-4"
            :href="`/${config.title}/${row.id}/edit`"
            tabindex="-1"
          >
            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
          </Link>
        </td>
      </tr>
      <tr v-if="data.data.length === 0">
        <td
          class="px-6 py-4 border-t capitalize text-center"
          :colspan="config.table.length + 1"
        >
          No data {{ config.title }} found.
        </td>
      </tr>
    </table>
  </div>
  <Pagination class="mt-6" :links="data.links" />
</template>

<script setup>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon.vue";
import Pagination from "./Pagination.vue";

const props = defineProps({
  config: Object,
  data: Object,
});

const showButtonCreate = props.config.buttonCreate ?? true;
</script>
